import { equipmentAPI } from "api";

export const getAllRequestHistoryAPI = () => {
    return equipmentAPI.get("api/dshistory/getalldshistory")
        .then((res) => res);
};